import { Link } from 'react-router-dom';
import activity from '../../../assets/images/icons/activity.svg';
import calendar from '../../../assets/images/icons/calendar.svg';
import comments from '../../../assets/images/icons/comments.svg';
import financial from '../../../assets/images/icons/financial.svg';
import folder from '../../../assets/images/icons/folder.svg';
import registrationData from '../../../assets/images/icons/registrationData.svg';
// import userTie from '../../../assets/images/icons/userTie.svg';
import { ActiveItem, MenuItem } from '../styles';

interface NavbarInterface {
  active: string;
}

export default function AdminNavbar({ active }: NavbarInterface) {
  return (
    <div style={{ maxHeight: '80vh', overflow: 'auto'}}>
      {active === 'RegistrationData'
        ? (
          <ActiveItem>
            <Link to="/">
              <MenuItem>
                <img src={registrationData} alt="registrationData" />
                Meu Cadastro
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/">
            <MenuItem>
              <img src={registrationData} alt="registrationData" />
              Meu Cadastro
            </MenuItem>
          </Link>
        )}


      {active === 'Forum'
        ? (
          <ActiveItem>
            <Link to="/forum">
              <MenuItem>
                <img src={comments} alt="forum" />
                Forum
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/forum">
            <MenuItem>
              <img src={comments} alt="forum" />
              Forum
            </MenuItem>
          </Link>
        )}

      {active === 'Activities'
        ? (
          <ActiveItem>
            <Link to="/activities">
              <MenuItem>
                <img src={activity} alt="activity" />
                Atividades
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/activities">
            <MenuItem>
              <img src={activity} alt="activity" />
              Atividades
            </MenuItem>
          </Link>
        )}

      {active === 'Schedules'
        ? (
          <ActiveItem>
            <Link to="/schedules">
              <MenuItem>
                <img src={calendar} alt="schedule" />
                Aulas/agendamentos
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/schedules">
            <MenuItem>
              <img src={calendar} alt="schedule" />
              Aulas/agendamentos
            </MenuItem>
          </Link>
        )}

      {active === 'Financial'
        ? (
          <ActiveItem>
            <Link to="/financial">
              <MenuItem>
                <img src={financial} alt="financial" />
                Financeiro
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/financial">
            <MenuItem>
              <img src={financial} alt="financial" />
              Financeiro
            </MenuItem>
          </Link>
        )}

      {/* {active === 'InternalUsers'
        ? (
          <ActiveItem>
            <Link to="/internalUsers">
              <MenuItem>
                <img src={userTie} alt="user" />
                Logins Adicionais
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/internalUsers">
            <MenuItem>
              <img src={userTie} alt="user" />
              Logins Adicionais
            </MenuItem>
          </Link>
        )} */}

      {active === 'Files'
        ? (
          <ActiveItem>
            <Link to="/files">
              <MenuItem>
                <img src={folder} alt="schedule" />
                Arquivos/materiais
              </MenuItem>
            </Link>
          </ActiveItem>
        )
        : (
          <Link to="/files">
            <MenuItem>
              <img src={folder} alt="schedule" />
              Arquivos/materiais
            </MenuItem>
          </Link>
        )}
    </div>
  );
}
